export const MOBILE_ALGO_VERSION = '1.0.0'
